import React from "react";
import styles from "./index.module.scss";
export default class Checkbox extends React.Component {
    render() {
        return (React.createElement("label", { className: styles.label },
            React.createElement("input", { type: "checkbox", onChange: this.props.change, checked: this.props.checked, className: styles.checkboxInput }),
            this.props.label && React.createElement("span", null, this.props.label)));
    }
}
